import React from "react";
import AddCircleOutline from "@material-ui/icons/AddCircleOutline";
import { Button } from "../../design-system";

type Props = {
  withCustomInactiveColor?: boolean;
  withCustomColor?: boolean;
  withCustomIcon?: boolean;

  customColor?: string;
  CustomIcon?: any;
  disabled?: boolean;
  withIcon?: boolean;
  action: Function;
  title: string;
};

const PlusIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const ActionButton = ({
  withCustomIcon,
  CustomIcon,
  withIcon,
  disabled,
  action,
  title,
}: Props) => {
  const renderIcon = () => {
    if (withCustomIcon && CustomIcon) {
      return <CustomIcon style={{ fontSize: 16 }} />;
    }
    if (withIcon) return <PlusIcon />;
    return undefined;
  };

  return (
    <Button
      variant="primary"
      size="md"
      iconLeft={renderIcon()}
      disabled={disabled}
      onClick={() => action()}
    >
      {title}
    </Button>
  );
};

export default ActionButton;
